export class WordingEvaluator {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get wording() {
        return this.parent;
    }
    get wordTask() {
        return this.parent.wordTask;
    }
    get successComparer() {
        if (this.wording.hearComparer.overallSimilar.reachedSimilarity > this.wording.inputComparer.overallSimilar.reachedSimilarity) {
            return this.wording.hearComparer;
        }
        return this.wording.inputComparer;
    }
    get successFrom() {
        if (this.successComparer === this.wording.hearComparer)
            return 'hear';
        return 'input';
    }
    get reachedSimilarity() {
        return this.successComparer.overallSimilar.reachedSimilarity;
    }
    get averageAlgorithmSimilarity() {
        return this.successComparer.overallSimilar.averageAlgorithmSimilarity;
    }
    get disproveComparer() {
        if (this.wording.inputComparer.overallConflict.disproveCertainty >= this.wording.hearComparer.overallConflict.disproveCertainty) {
            return this.wording.inputComparer;
        }
        if (this.wording.hearComparer.bestWordingGuess && this.wording.hearComparer.bestWordingGuess.guess.phrase.isFinal) {
            return this.wording.hearComparer;
        }
        return this.wording.inputComparer;
    }
    get disproveCertainty() {
        return this.disproveComparer.overallConflict.disproveCertainty;
    }
    get disproveFrom() {
        if (this.disproveComparer === this.wording.hearComparer)
            return 'hear';
        return 'input';
    }
}
